import { create, METHOD } from '../utils'

export default {

    /** 查询列表 */
    webOauth2: (props: {
        code: string,
        url: string
    }) => create({
        url: "/egg/wx/webOauth2",
        method: METHOD.GET
    })(props),

    /** 查询列表 */
    getTicket: (props: {
        url: string
    }) => create({
        url: "/egg/wx/getTicket",
        method: METHOD.GET
    })(props),

    /** 查询列表 */
    token: create({
        url: "/egg/wx/token",
        method: METHOD.GET
    }),

    /** 查询列表 */
    sendTemplateMsg: create({
        url: "/egg/wx/sendTemplateMsg",
        method: METHOD.POST
    }),
}